import api from 'api';

export const loadManagers = api('GET /api/users/fields/managers');

export const loadAffiliates = api('GET /api/users/fields/affiliates');
export const loadActions = api('GET /api/users/fields/actions');
export const loadApplications = api('GET /api/users/fields/applications');
export const loadNetworks = api('GET /api/users/fields/networks');
export const loadCustomerCompanies = api(
  'GET /api/users/fields/customer-companies'
);

export const loadDepartments = api('GET /api/users/fields/departments');
export const loadPositions = api('GET /api/users/fields/positions');
export const loadCompanies = api('GET /api/users/fields/companies');
export const loadStudios = api('GET /api/users/fields/studios');
export const loadSuperTeams = api('GET /api/users/fields/superteams');
export const loadTeams = api('GET /api/users/fields/teams');
export const loadRoles = api('GET /api/users/fields/roles');
export const loadRolePermissions = api('GET /api/users/roles/:id');
